/**
 * Fill the table from a spreadsheet.
 *
 * The file is read on the server, which only hands back values for requests that
 * are open for this customer. They land in the fields, so everything can still
 * be checked and corrected before anything is submitted.
 */

/**
 * @returns {string} the CSRF token, or empty when the meta tag is gone
 */
function csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');

    return meta ? meta.content : '';
}

document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.getElementById('use-xls-csv');
    const panel = document.getElementById('use-xls-csv-panel');

    if (!toggle || !panel) {
        return;
    }

    /** Match the panel to the switch, which a reload can restore out of step. */
    const applyPanel = function () {
        panel.hidden = !toggle.checked;
    };

    toggle.addEventListener('change', applyPanel);

    // A browser restores the switch on a reload, while the panel comes back hidden
    // from the server: without this the switch says it is on and nothing is there.
    applyPanel();

    const button = document.getElementById('import-readings');
    const file = document.getElementById('import-readings-file');

    if (!button || !file) {
        return;
    }

    button.addEventListener('click', function () {
        file.click();
    });

    file.addEventListener('change', function () {
        if (!file.files || !file.files.length) {
            return;
        }

        const data = new FormData();
        data.append('file', file.files[0]);

        const spinner = document.getElementById('import-readings-spinner');

        button.disabled = true;

        if (spinner) {
            spinner.hidden = false;
        }

        fetch(panel.dataset.importUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrfToken(),
            },
            body: data,
        }).then(function (response) {
            return response.json().catch(function () {
                return null;
            });
        }).then(function (result) {
            button.disabled = false;
            file.value = '';

            if (spinner) {
                spinner.hidden = true;
            }

            let message = panel.querySelector('.import-readings-message');

            if (!message) {
                message = document.createElement('div');
                message.className = 'import-readings-message';
                panel.appendChild(message);
            }

            if (!result || !result.rows) {
                message.className = 'import-readings-message invalid-feedback d-block';
                message.textContent = (result && result.error) ? result.error : '';

                return;
            }

            let filled = 0;

            Object.keys(result.rows).forEach(function (flowId) {
                const row = document.querySelector('.multiple-readings-row[data-flow-id="' + flowId + '"]');

                if (!row) {
                    return;
                }

                const imported = result.rows[flowId];
                const dateInput = row.querySelector('.reading-date');

                if (dateInput && imported.date) {
                    dateInput.value = imported.date;
                    // the listener on this redraws the expected ranges, which otherwise
                    // keep belonging to the date the row had before the import
                    dateInput.dispatchEvent(new Event('change', { bubbles: true }));
                }

                let rowFilled = 0;

                Object.keys(imported.readings || {}).forEach(function (dial) {
                    const input = row.querySelector('[name="rows[' + flowId + '][readings][' + dial + ']"]');

                    if (input) {
                        input.value = imported.readings[dial];
                        // the field carries an input mask that has to see the value
                        input.dispatchEvent(new Event('input', { bubbles: true }));
                        // Marked until it is touched: these values come from a file
                        // and nobody has looked at them in the table yet. The class
                        // goes on after the event above, which is what clears it.
                        input.classList.add('is-imported');
                        filled++;
                        rowFilled++;
                    }
                });

                if (rowFilled) {
                    // one verdict for the whole row: everything in it was just
                    // filled in, so everything in it deserves an answer
                    row.dispatchEvent(new CustomEvent('readings:filled', { bubbles: true }));
                }
            });

            message.className = 'import-readings-message';
            message.textContent = message.dataset.filled
                ? message.dataset.filled.replace(':count', filled)
                : '';
        }).catch(function () {
            button.disabled = false;
            file.value = '';

            if (spinner) {
                spinner.hidden = true;
            }
        });
    });
});
